import React, { useState, useEffect } from 'react';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8002/api/v1';

const CITIES_BY_REGION = {
  'الرياض':            ['الرياض','الخرج','الأفلاج','الدوادمي','الزلفي','السليل','المجمعة','القويعية','حريملاء','شقراء','ضرما','عفيف','وادي الدواسر'],
  'مكة المكرمة':       ['جدة','مكة المكرمة','الطائف','رابغ','القنفذة','الليث','المويه','الجموم'],
  'المدينة المنورة':   ['المدينة المنورة','ينبع','العلا','بدر','الحناكية','المهد','خيبر','وادي الفرع'],
  'القصيم':            ['بريدة','عنيزة','الرس','البكيرية','المذنب','الأسياح','الشماسية','ضرية','رياض الخبراء'],
  'الشرقية':           ['الدمام','الخبر','الظهران','القطيف','الأحساء','الجبيل','حفر الباطن','الخفجي','النعيرية'],
  'عسير':              ['أبها','خميس مشيط','النماص','محايل عسير','بيشة','سراة عبيدة','رجال ألمع','البرك','ظهران الجنوب'],
  'تبوك':              ['تبوك','ضباء','تيماء','حقل','قيال','الوجه'],
  'حائل':              ['حائل','بقعاء','الغزالة','الشنان','الحائط','موقق'],
  'جازان':             ['جازان','صبياء','صامطة','أبو عريش','فرسان','العيدابي','بيش','الريث','الطوال'],
  'نجران':             ['نجران','شرورة','حبونا','ثار','يدمة'],
  'الباحة':            ['الباحة','بلجرشي','المندق','المخواة','القرى','العقيق','غامد الزناد'],
  'الجوف':             ['سكاكا','القريات','دومة الجندل','طبرجل'],
  'الحدود الشمالية':   ['عرعر','رفحاء','طريف','العويقيلة'],
};
const SAUDI_REGIONS = Object.keys(CITIES_BY_REGION);
const ALL_CITIES = [...new Set(Object.values(CITIES_BY_REGION).flat())].sort((a,b)=>a.localeCompare(b,'ar'));
const WATER_TYPES = [
  { key: 'drinking',     label: 'مياه شرب' },
  { key: 'non_drinking', label: 'مياه غير صالحة للشرب' },
  { key: 'treated',      label: 'مياه معالجة' },
];

const ROLES = [
  {
    id: 'customer', label: 'عميل', sub: 'اطلب المياه لمنزلك أو مشروعك',
    color: 'from-blue-500 to-cyan-500',
    icon: <svg className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" /></svg>,
  },
  {
    id: 'driver', label: 'سائق', sub: 'وصّل الطلبات واكسب من عملك',
    color: 'from-emerald-500 to-teal-500',
    icon: <svg className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M8.25 18.75a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 01-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 00-3.213-9.193 2.056 2.056 0 00-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 00-10.026 0 1.106 1.106 0 00-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12" /></svg>,
  },
  {
    id: 'tenant', label: 'شركة مياه', sub: 'أدر طلبات التوصيل وفريقك',
    color: 'from-violet-500 to-purple-500',
    icon: <svg className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M3.75 21h16.5M4.5 3h15M5.25 3v18m13.5-18v18M9 6.75h1.5m-1.5 3h1.5m-1.5 3h1.5m3-6H15m-1.5 3H15m-1.5 3H15M9 21v-3.375c0-.621.504-1.125 1.125-1.125h3.75c.621 0 1.125.504 1.125 1.125V21" /></svg>,
  },
];

/* ─────────────────────────────────────── Step icon definitions ── */
const IC_USER   = <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" /></svg>;
const IC_DOC    = <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" /></svg>;
const IC_CHECK  = <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>;
const IC_BUILD  = <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M3.75 21h16.5M4.5 3h15M5.25 3v18m13.5-18v18M9 6.75h1.5m-1.5 3h1.5m-1.5 3h1.5m3-6H15m-1.5 3H15m-1.5 3H15M9 21v-3.375c0-.621.504-1.125 1.125-1.125h3.75c.621 0 1.125.504 1.125 1.125V21" /></svg>;
const IC_BRIEF  = <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 00.75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 00-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0112 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 01-.673-.38m0 0A2.18 2.18 0 013 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 013.413-.387m7.5 0V5.25A2.25 2.25 0 0013.5 3h-3a2.25 2.25 0 00-2.25 2.25v.894m7.5 0a48.667 48.667 0 00-7.5 0M12 12.75h.008v.008H12v-.008z" /></svg>;
const IC_DONE   = <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}><path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" /></svg>;

const DRV_STEPS   = [
  { id: 1, label: 'البيانات الشخصية', icon: IC_USER },
  { id: 2, label: 'الوثائق المطلوبة', icon: IC_DOC },
  { id: 3, label: 'تأكيد ومراجعة',   icon: IC_CHECK },
];
const TNT_STEPS   = [
  { id: 1, label: 'معلومات الشركة',   icon: IC_BUILD },
  { id: 2, label: 'المسؤول والترخيص', icon: IC_BRIEF },
  { id: 3, label: 'تأكيد ومراجعة',   icon: IC_CHECK },
];

/* ═══════════════════════════════════════════════════════════════ */
export default function RegisterPage() {
  const [role,     setRole]     = useState(null);
  const [screen,   setScreen]   = useState('role'); // role | form | success
  const [formStep, setFormStep] = useState(1);
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState('');
  const [showPw,   setShowPw]   = useState(false);

  /* ── Customer ── */
  const [cust, setCust] = useState({ name:'', phone:'', email:'', password:'', confirm:'' });
  const setC = (k,v) => setCust(p=>({...p,[k]:v}));

  /* ── Driver ── */
  const [drv, setDrv] = useState({ full_name:'', phone:'', national_id:'', password:'', confirm:'' });
  const [drvReqDefs, setDrvReqDefs] = useState([]);
  const [drvReqData, setDrvReqData] = useState({});
  const setD = (k,v) => setDrv(p=>({...p,[k]:v}));
  const setDR = (k,v) => setDrvReqData(p=>({...p,[k]:v}));

  /* ── Tenant ── */
  const [company, setCompany] = useState({ name:'', name_en:'', city:'', region:'', phone:'', water_types:[] });
  const [owner,   setOwner]   = useState({ owner_name:'', owner_phone:'', email:'', password:'', confirm:'' });
  const [tntReqDefs, setTntReqDefs] = useState([]);
  const [tntReqData, setTntReqData] = useState({});
  const setCo = (k,v) => setCompany(p=>({...p,[k]:v}));
  const setOw = (k,v) => setOwner(p=>({...p,[k]:v}));
  const setRegion = (v) => setCompany(p=>({...p, region:v, city:''})); // reset city on region change
  const availableCities = company.region ? (CITIES_BY_REGION[company.region] || []) : ALL_CITIES;
  const setTR = (k,v) => setTntReqData(p=>({...p,[k]:v}));

  const toggleWater = (key) =>
    setCompany(p=>({ ...p, water_types: p.water_types.includes(key)
      ? p.water_types.filter(k=>k!==key) : [...p.water_types,key] }));

  /* Load requirements on role select */
  useEffect(() => {
    if (role === 'driver') {
      fetch(`${API_BASE}/driver/auth/register/requirements`)
        .then(r=>r.json()).then(d=>setDrvReqDefs(Array.isArray(d)?d:[])).catch(()=>{});
    }
    if (role === 'tenant') {
      fetch(`${API_BASE}/tenant/auth/register/requirements`)
        .then(r=>r.json()).then(d=>setTntReqDefs(Array.isArray(d)?d:[])).catch(()=>{});
    }
  }, [role]);

  /* ── Validations ── */
  const validateDrv1 = () => {
    if (!drv.full_name.trim()) return 'الاسم الكامل مطلوب';
    if (!/^(05|5)\d{8}$/.test(drv.phone.trim())) return 'رقم الجوال غير صحيح (يبدأ بـ 05)';
    if (drv.national_id.trim() && !/^[12]\d{9}$/.test(drv.national_id.trim()))
      return 'رقم الهوية يجب أن يكون 10 أرقام ويبدأ بـ 1 أو 2';
    if (drv.password.length < 6) return 'كلمة المرور 6 أحرف على الأقل';
    if (drv.password !== drv.confirm) return 'كلمتا المرور غير متطابقتين';
    return null;
  };
  const validateDrv2 = () => {
    for (const r of drvReqDefs.filter(r=>r.is_required))
      if (!drvReqData[r.field_key]) return `حقل "${r.field_name_ar}" مطلوب`;
    return null;
  };
  const validateTnt1 = () => {
    if (!company.name.trim()) return 'اسم الشركة مطلوب';
    if (!company.region) return 'المنطقة الإدارية مطلوبة';
    if (!company.city) return 'المدينة مطلوبة';
    if (!/^(05|5)\d{8}$/.test(company.phone.trim())) return 'رقم جوال الشركة غير صحيح';
    return null;
  };
  const validateTnt2 = () => {
    if (!owner.owner_name.trim()) return 'اسم المسؤول مطلوب';
    if (!owner.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(owner.email)) return 'البريد الإلكتروني غير صحيح';
    if (owner.password.length < 6) return 'كلمة المرور 6 أحرف على الأقل';
    if (owner.password !== owner.confirm) return 'كلمتا المرور غير متطابقتين';
    return null;
  };

  const goNext = () => {
    setError('');
    let err = null;
    if (role === 'driver') { err = formStep===1 ? validateDrv1() : validateDrv2(); }
    if (role === 'tenant') { err = formStep===1 ? validateTnt1() : validateTnt2(); }
    if (err) { setError(err); return; }
    setFormStep(s=>s+1);
  };

  /* ── Submit ── */
  const submit = async () => {
    setError(''); setLoading(true);
    try {
      if (role === 'customer') {
        if (cust.password !== cust.confirm) { setError('كلمتا المرور غير متطابقتين'); return; }
        const data = await fetch(`${API_BASE}/customer/auth/register`, {
          method:'POST', headers:{'Content-Type':'application/json'},
          body: JSON.stringify({ display_name:cust.name.trim(), phone:cust.phone.trim(), email:cust.email.trim()||undefined, password:cust.password }),
        }).then(async r => { const d=await r.json(); if(!r.ok) throw new Error(d.detail||'خطأ'); return d; });
        localStorage.setItem('watrly_customer_token', data.access_token);
        if (data.refresh_token) localStorage.setItem('watrly_customer_refresh_token', data.refresh_token);
        if (data.customer) localStorage.setItem('watrly_customer_data', JSON.stringify(data.customer));
        window.location.href = '/customer/home';
      } else if (role === 'driver') {
        await fetch(`${API_BASE}/driver/auth/register`, {
          method:'POST', headers:{'Content-Type':'application/json'},
          body: JSON.stringify({ full_name:drv.full_name.trim(), phone:drv.phone.trim(), national_id:drv.national_id.trim()||null, password:drv.password, requirements_data:drvReqData }),
        }).then(async r => { const d=await r.json(); if(!r.ok) throw new Error(d.detail||'خطأ'); return d; });
        setScreen('success');
      } else if (role === 'tenant') {
        await fetch(`${API_BASE}/tenant/auth/register`, {
          method:'POST', headers:{'Content-Type':'application/json'},
          body: JSON.stringify({ company_name:company.name.trim(), company_name_en:company.name_en.trim()||null, city:company.city, region:company.region||null, phone:company.phone.trim(), email:owner.email.trim().toLowerCase(), password:owner.password, owner_name:owner.owner_name.trim(), owner_phone:owner.owner_phone.trim()||null, requirements_data:{ water_types:company.water_types, ...tntReqData } }),
        }).then(async r => { const d=await r.json(); if(!r.ok) throw new Error(d.detail||'خطأ'); return d; });
        setScreen('success');
      }
    } catch(e) { setError(e.message); }
    finally { setLoading(false); }
  };

  const selectRole = (r) => { setRole(r); setScreen('form'); setFormStep(1); setError(''); };
  const backToRoles = () => { setScreen('role'); setRole(null); setError(''); setFormStep(1); };
  const roleInfo = ROLES.find(r=>r.id===role);
  const steps = role==='driver' ? DRV_STEPS : role==='tenant' ? TNT_STEPS : [];

  /* ─── Render ─── */
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-950 to-slate-900 flex items-start justify-center p-4 py-10" dir="rtl">
      <div className="w-full max-w-md">

        {/* Logo */}
        <div className="text-center mb-8">
          <a href="/" className="inline-flex flex-col items-center gap-2">
            <div className="w-14 h-14 rounded-2xl bg-white/10 backdrop-blur flex items-center justify-center">
              <svg className="w-8 h-8 text-cyan-400" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2c-5.33 4.55-8 8.48-8 11.8 0 4.98 3.8 8.2 8 8.2s8-3.22 8-8.2c0-3.32-2.67-7.25-8-11.8z"/>
              </svg>
            </div>
            <span className="text-2xl font-bold text-white">وترلي</span>
          </a>
          <p className="text-white/50 text-sm mt-1">إنشاء حساب جديد</p>
        </div>

        <div className="bg-white/[0.07] backdrop-blur-xl border border-white/10 rounded-3xl p-6 shadow-2xl">

          {/* ════ ROLE SELECTOR ════ */}
          {screen === 'role' && (
            <>
              <h2 className="text-xl font-bold text-white mb-1 text-center">أنت؟</h2>
              <p className="text-white/50 text-sm text-center mb-6">اختر نوع حسابك للمتابعة</p>
              <div className="space-y-3">
                {ROLES.map(r => (
                  <button key={r.id} onClick={() => selectRole(r.id)}
                    className="w-full flex items-center gap-4 p-4 rounded-2xl border border-white/10 bg-white/5 hover:border-white/30 hover:bg-white/10 transition-all group text-right">
                    <div className={`w-12 h-12 rounded-xl bg-gradient-to-br ${r.color} flex items-center justify-center text-white flex-shrink-0`}>
                      {r.icon}
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="font-bold text-white text-base">{r.label}</div>
                      <div className="text-white/50 text-xs mt-0.5">{r.sub}</div>
                    </div>
                    <svg className="w-4 h-4 text-white/30 group-hover:text-white/60 flex-shrink-0 rotate-180" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" /></svg>
                  </button>
                ))}
              </div>
              <div className="mt-5 text-center">
                <span className="text-white/40 text-sm">لديك حساب؟ </span>
                <a href="/login" className="text-cyan-400 text-sm font-semibold hover:underline">سجّل دخولك</a>
              </div>
            </>
          )}

          {/* ════ FORM ════ */}
          {screen === 'form' && (
            <>
              {/* Back + role badge */}
              <div className="flex items-center gap-3 mb-5">
                <button onClick={backToRoles}
                  className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-white/20 transition-colors flex-shrink-0">
                  <svg className="w-4 h-4 rotate-180" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" /></svg>
                </button>
                <span className={`px-3 py-1 rounded-full text-xs font-bold text-white bg-gradient-to-r ${roleInfo?.color}`}>
                  {roleInfo?.label}
                </span>
              </div>

              {/* Step bar (driver / tenant) */}
              {steps.length > 0 && (
                <StepBar steps={steps} current={formStep} />
              )}

              {error && (
                <div className="mb-4 px-4 py-3 rounded-xl bg-red-500/20 border border-red-500/30 text-red-300 text-sm">{error}</div>
              )}

              {/* ── CUSTOMER ── */}
              {role === 'customer' && (
                <form onSubmit={e=>{e.preventDefault();submit();}} className="space-y-4">
                  <h2 className="text-lg font-bold text-white mb-4">إنشاء حساب عميل</h2>
                  <Field label="الاسم الكامل" value={cust.name} onChange={v=>setC('name',v)} placeholder="أدخل اسمك الكامل" />
                  <Field label="رقم الهاتف" value={cust.phone} onChange={v=>setC('phone',v)} type="tel" placeholder="05xxxxxxxx" dir="ltr" />
                  <Field label="البريد الإلكتروني (اختياري)" value={cust.email} onChange={v=>setC('email',v)} type="email" placeholder="example@email.com" dir="ltr" required={false} />
                  <PwField label="كلمة المرور" value={cust.password} onChange={v=>setC('password',v)} show={showPw} onToggle={()=>setShowPw(p=>!p)} />
                  <PwField label="تأكيد كلمة المرور" value={cust.confirm} onChange={v=>setC('confirm',v)} show={showPw} onToggle={()=>setShowPw(p=>!p)} placeholder="أعد إدخال كلمة المرور" />
                  <SubmitBtn loading={loading} color="from-blue-500 to-cyan-500" label="إنشاء الحساب" />
                  <div className="text-center pt-1">
                    <span className="text-white/40 text-xs">لديك حساب؟ </span>
                    <a href="/login" className="text-cyan-400 text-xs font-semibold hover:underline">سجّل دخولك</a>
                  </div>
                </form>
              )}

              {/* ── DRIVER STEP 1 ── */}
              {role === 'driver' && formStep === 1 && (
                <div className="space-y-4">
                  <p className="text-white/60 text-sm mb-2">أدخل بياناتك الشخصية للتسجيل</p>
                  <Field label="الاسم الكامل *" value={drv.full_name} onChange={v=>setD('full_name',v)} placeholder="محمد أحمد العلي" />
                  <Field label="رقم الجوال *" value={drv.phone} onChange={v=>setD('phone',v)} type="tel" placeholder="05XXXXXXXX" dir="ltr" />
                  <Field label="رقم الهوية / الإقامة" value={drv.national_id} onChange={v=>setD('national_id',v)} placeholder="1XXXXXXXXX" dir="ltr" required={false} />
                  <PwField label="كلمة المرور *" value={drv.password} onChange={v=>setD('password',v)} show={showPw} onToggle={()=>setShowPw(p=>!p)} />
                  <PwField label="تأكيد كلمة المرور *" value={drv.confirm} onChange={v=>setD('confirm',v)} show={showPw} onToggle={()=>setShowPw(p=>!p)} placeholder="أعد الكتابة" />
                  <NavBtns onNext={goNext} color="from-emerald-500 to-teal-500" />
                </div>
              )}

              {/* ── DRIVER STEP 2 ── */}
              {role === 'driver' && formStep === 2 && (
                <div className="space-y-4">
                  <p className="text-white/60 text-sm mb-2">الحقول بـ * إلزامية — يمكن إكمال الباقي لاحقاً</p>
                  {drvReqDefs.length === 0 ? (
                    <div className="text-center py-6">
                      <svg className="w-10 h-10 text-white/20 mx-auto mb-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1}><path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m6.75 12l-3-3m0 0l-3 3m3-3v6m-1.5-15H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" /></svg>
                      <p className="text-white/40 text-sm">لا توجد وثائق مطلوبة في هذه المرحلة</p>
                    </div>
                  ) : (() => {
                    const groups = {};
                    drvReqDefs.forEach(req => {
                      const g = req.group_key || 'other';
                      if (!groups[g]) groups[g] = { label: req.group_name_ar || 'أخرى', fields: [] };
                      groups[g].fields.push(req);
                    });
                    return Object.entries(groups).map(([gk, grp]) => (
                      <div key={gk}>
                        <div className="flex items-center gap-2 mt-3 mb-3">
                          <div className="flex-1 h-px bg-white/10"/>
                          <span className="text-white/40 text-xs font-semibold px-2">{grp.label}</span>
                          <div className="flex-1 h-px bg-white/10"/>
                        </div>
                        {grp.fields.map(req => (
                          <div key={req.field_key} className="mb-3">
                            <ReqField req={req} value={drvReqData[req.field_key]||''} onChange={v=>setDR(req.field_key,v)} />
                          </div>
                        ))}
                      </div>
                    ));
                  })()}
                  <NavBtns onPrev={()=>setFormStep(1)} onNext={goNext} color="from-emerald-500 to-teal-500" />
                </div>
              )}

              {/* ── DRIVER STEP 3 ── */}
              {role === 'driver' && formStep === 3 && (
                <div className="space-y-4">
                  <p className="text-white/60 text-sm mb-2">راجع بياناتك قبل الإرسال</p>
                  <ReviewCard title="البيانات الشخصية" rows={[['الاسم',drv.full_name],['الجوال',drv.phone],['الهوية',drv.national_id||'—']]} />
                  <div className="px-4 py-3 rounded-xl bg-emerald-500/10 border border-emerald-500/20 text-emerald-300 text-xs leading-relaxed">
                    <svg className="w-4 h-4 inline-block ml-1 mb-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" /></svg>
                    سيتم مراجعة طلبك من قِبَل الشركة أو مشرفي المنصة وإشعارك عند الموافقة
                  </div>
                  <div className="flex gap-2 pt-1">
                    <button onClick={()=>setFormStep(2)} className="flex-1 py-3 rounded-2xl bg-white/10 text-white/70 text-sm font-semibold hover:bg-white/20 transition-colors">رجوع</button>
                    <button onClick={submit} disabled={loading}
                      className="flex-[2] py-3 rounded-2xl bg-gradient-to-r from-emerald-500 to-teal-500 text-white font-bold text-sm hover:opacity-90 active:scale-[0.98] transition-all disabled:opacity-50 flex items-center justify-center gap-2">
                      {loading ? <Spinner/> : <>
                        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5" /></svg>
                        إرسال الطلب
                      </>}
                    </button>
                  </div>
                </div>
              )}

              {/* ── TENANT STEP 1 ── */}
              {role === 'tenant' && formStep === 1 && (
                <div className="space-y-4">
                  <p className="text-white/60 text-sm mb-2">أدخل المعلومات الأساسية لشركتك</p>
                  <Field label="اسم الشركة (عربي) *" value={company.name} onChange={v=>setCo('name',v)} placeholder="شركة مياه الرياض" />
                  <Field label="اسم الشركة (إنجليزي)" value={company.name_en} onChange={v=>setCo('name_en',v)} placeholder="Riyadh Water Company" dir="ltr" required={false} />
                  <SelectField label="المنطقة الإدارية *" value={company.region} onChange={setRegion} options={SAUDI_REGIONS} />
                  <SelectField label="المدينة *" value={company.city} onChange={v=>setCo('city',v)} options={availableCities} />
                  <Field label="رقم جوال الشركة *" value={company.phone} onChange={v=>setCo('phone',v)} type="tel" placeholder="05XXXXXXXX" dir="ltr" />
                  <div>
                    <label className="block text-sm font-medium text-white/70 mb-2">أنواع المياه</label>
                    <div className="space-y-2">
                      {WATER_TYPES.map(wt => (
                        <button key={wt.key} type="button" onClick={()=>toggleWater(wt.key)}
                          className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl border transition-all text-right ${company.water_types.includes(wt.key) ? 'border-cyan-500/60 bg-cyan-500/10 text-white' : 'border-white/10 bg-white/5 text-white/60 hover:border-white/20'}`}>
                          <span className="flex-1 text-sm font-medium">{wt.label}</span>
                          <span className={`w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${company.water_types.includes(wt.key) ? 'border-cyan-400 bg-cyan-400' : 'border-white/30'}`}>
                            {company.water_types.includes(wt.key) && IC_DONE}
                          </span>
                        </button>
                      ))}
                    </div>
                  </div>
                  <NavBtns onNext={goNext} color="from-violet-500 to-purple-500" />
                </div>
              )}

              {/* ── TENANT STEP 2 ── */}
              {role === 'tenant' && formStep === 2 && (
                <div className="space-y-4">
                  <p className="text-white/60 text-sm mb-2">بيانات المسؤول عن الحساب</p>
                  <Field label="اسم المالك / المدير *" value={owner.owner_name} onChange={v=>setOw('owner_name',v)} placeholder="أحمد محمد العلي" />
                  <Field label="جوال المسؤول" value={owner.owner_phone} onChange={v=>setOw('owner_phone',v)} type="tel" placeholder="05XXXXXXXX" dir="ltr" required={false} />
                  <Field label="البريد الإلكتروني (للدخول) *" value={owner.email} onChange={v=>setOw('email',v)} type="email" placeholder="info@company.com" dir="ltr" />
                  <PwField label="كلمة المرور *" value={owner.password} onChange={v=>setOw('password',v)} show={showPw} onToggle={()=>setShowPw(p=>!p)} />
                  <PwField label="تأكيد كلمة المرور *" value={owner.confirm} onChange={v=>setOw('confirm',v)} show={showPw} onToggle={()=>setShowPw(p=>!p)} placeholder="أعد الكتابة" />

                  {/* Dynamic requirements — all of them, grouped */}
                  {tntReqDefs.length > 0 && (() => {
                    const groups = {};
                    tntReqDefs.forEach(req => {
                      const g = req.group_key || 'other';
                      if (!groups[g]) groups[g] = { label: req.group_name_ar || 'أخرى', fields: [] };
                      groups[g].fields.push(req);
                    });
                    return Object.entries(groups).map(([gk, grp]) => (
                      <div key={gk}>
                        <div className="flex items-center gap-2 mt-2 mb-3">
                          <div className="flex-1 h-px bg-white/10"/>
                          <span className="text-white/40 text-xs font-semibold uppercase tracking-wider px-2">{grp.label}</span>
                          <div className="flex-1 h-px bg-white/10"/>
                        </div>
                        {grp.fields.map(req => (
                          <div key={req.field_key} className="mb-3">
                            <ReqField req={req} value={tntReqData[req.field_key]||''} onChange={v=>setTR(req.field_key,v)} />
                          </div>
                        ))}
                      </div>
                    ));
                  })()}

                  <NavBtns onPrev={()=>setFormStep(1)} onNext={goNext} color="from-violet-500 to-purple-500" />
                </div>
              )}

              {/* ── TENANT STEP 3 ── */}
              {role === 'tenant' && formStep === 3 && (
                <div className="space-y-4">
                  <p className="text-white/60 text-sm mb-2">راجع بياناتك قبل الإرسال</p>
                  <ReviewCard title="بيانات الشركة" rows={[['الاسم',company.name],['المنطقة',company.region],['المدينة',company.city],['الجوال',company.phone],['أنواع المياه',company.water_types.map(k=>WATER_TYPES.find(w=>w.key===k)?.label).join('، ')||'—']]} />
                  <ReviewCard title="المسؤول" rows={[['الاسم',owner.owner_name],['البريد',owner.email]]} />
                  <div className="px-4 py-3 rounded-xl bg-violet-500/10 border border-violet-500/20 text-violet-300 text-xs leading-relaxed">
                    <svg className="w-4 h-4 inline-block ml-1 mb-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" /></svg>
                    سيراجع فريق وترلي طلبكم ويتم تفعيل الحساب خلال 2-3 أيام عمل
                  </div>
                  <div className="flex gap-2 pt-1">
                    <button onClick={()=>setFormStep(2)} className="flex-1 py-3 rounded-2xl bg-white/10 text-white/70 text-sm font-semibold hover:bg-white/20 transition-colors">رجوع</button>
                    <button onClick={submit} disabled={loading}
                      className="flex-[2] py-3 rounded-2xl bg-gradient-to-r from-violet-500 to-purple-500 text-white font-bold text-sm hover:opacity-90 active:scale-[0.98] transition-all disabled:opacity-50 flex items-center justify-center gap-2">
                      {loading ? <Spinner/> : <>
                        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5" /></svg>
                        إرسال الطلب
                      </>}
                    </button>
                  </div>
                </div>
              )}
            </>
          )}

          {/* ════ SUCCESS ════ */}
          {screen === 'success' && (
            <div className="text-center py-4">
              <div className="w-16 h-16 rounded-2xl bg-white/10 flex items-center justify-center mx-auto mb-5">
                <svg className="w-9 h-9 text-emerald-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
              </div>
              <h3 className="text-xl font-bold text-white mb-2">تم استلام طلبك!</h3>
              <p className="text-white/60 text-sm leading-relaxed mb-6">
                {role === 'tenant'
                  ? 'سيراجع فريق وترلي طلب شركتك ويتواصل معك عند الموافقة خلال 2-3 أيام عمل.'
                  : 'سيتم مراجعة طلب تسجيلك من قبل الشركة وستصلك رسالة عند القبول.'}
              </p>
              <a href="/login"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-2xl bg-gradient-to-r from-emerald-500 to-teal-500 text-white font-bold text-sm hover:opacity-90 transition-opacity">
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75" /></svg>
                العودة لتسجيل الدخول
              </a>
            </div>
          )}
        </div>

        <p className="text-center text-white/20 text-xs mt-6">© {new Date().getFullYear()} وترلي — جميع الحقوق محفوظة</p>
      </div>
    </div>
  );
}

/* ═══════════════ Shared components ═══════════════ */

function StepBar({ steps, current }) {
  return (
    <div className="flex items-center mb-6">
      {steps.map((s, i) => (
        <React.Fragment key={s.id}>
          <div className="flex flex-col items-center flex-shrink-0">
            <div className={`w-8 h-8 rounded-full flex items-center justify-center transition-all ${
              current > s.id  ? 'bg-emerald-500 text-white' :
              current === s.id ? 'bg-white/20 text-white ring-2 ring-white/40' :
              'bg-white/10 text-white/30'}`}>
              {current > s.id ? IC_DONE : s.icon}
            </div>
            <span className={`text-xs mt-1 max-w-[56px] text-center leading-tight ${current===s.id?'text-white/80 font-semibold':'text-white/30'}`}>{s.label}</span>
          </div>
          {i < steps.length-1 && (
            <div className={`flex-1 h-px mx-1 mb-5 ${current > s.id ? 'bg-emerald-500/60' : 'bg-white/10'}`}/>
          )}
        </React.Fragment>
      ))}
    </div>
  );
}

function Field({ label, value, onChange, type='text', placeholder, dir, required=true }) {
  return (
    <div>
      <label className="block text-sm font-medium text-white/70 mb-1.5">{label}</label>
      <input type={type} value={value} onChange={e=>onChange(e.target.value)}
        placeholder={placeholder} dir={dir} required={required}
        className="w-full px-4 py-3 rounded-xl bg-white/10 border border-white/10 text-white placeholder-white/30 focus:outline-none focus:ring-2 focus:ring-white/20 focus:border-white/30 transition-all text-sm"/>
    </div>
  );
}

function SelectField({ label, value, onChange, options, required=true }) {
  return (
    <div>
      <label className="block text-sm font-medium text-white/70 mb-1.5">{label}</label>
      <select value={value} onChange={e=>onChange(e.target.value)} required={required}
        className="w-full px-3 py-3 rounded-xl bg-white/10 border border-white/10 text-white focus:outline-none focus:ring-2 focus:ring-white/20 transition-all text-sm">
        <option value="" className="bg-slate-900">— اختر —</option>
        {options.map(o=><option key={o} value={o} className="bg-slate-900">{o}</option>)}
      </select>
    </div>
  );
}

function PwField({ label, value, onChange, show, onToggle, placeholder='••••••••' }) {
  return (
    <div>
      <label className="block text-sm font-medium text-white/70 mb-1.5">{label}</label>
      <div className="relative">
        <input type={show?'text':'password'} value={value} onChange={e=>onChange(e.target.value)}
          placeholder={placeholder} required minLength={6}
          className="w-full px-4 py-3 rounded-xl bg-white/10 border border-white/10 text-white placeholder-white/30 focus:outline-none focus:ring-2 focus:ring-white/20 focus:border-white/30 transition-all text-sm pr-4 pl-10"/>
        <button type="button" onClick={onToggle}
          className="absolute left-3 top-1/2 -translate-y-1/2 text-white/40 hover:text-white/70 transition-colors p-1">
          {show
            ? <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88" /></svg>
            : <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z" /><path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /></svg>}
        </button>
      </div>
    </div>
  );
}

function ReqField({ req, value, onChange }) {
  const [uploading, setUploading] = useState(false);
  const [uploadErr, setUploadErr] = useState('');
  const cls = "w-full px-4 py-3 rounded-xl bg-white/10 border border-white/10 text-white placeholder-white/30 focus:outline-none focus:ring-2 focus:ring-white/20 focus:border-white/30 transition-all text-sm";
  const selCls = cls + " bg-slate-800";

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true); setUploadErr('');
    try {
      const fd = new FormData();
      fd.append('file', file);
      const res = await fetch(`${API_BASE}/driver/auth/upload`, { method: 'POST', body: fd });
      const d = await res.json();
      if (!res.ok) throw new Error(d.detail || 'فشل الرفع');
      onChange(d.url);
    } catch(err) {
      setUploadErr(err.message);
    } finally {
      setUploading(false);
    }
  };

  const opts = Array.isArray(req.options) ? req.options : [];

  return (
    <div>
      <label className="block text-sm font-medium text-white/70 mb-1.5">
        {req.field_name_ar}{req.is_required && <span className="text-red-400 mr-0.5">*</span>}
      </label>

      {req.field_type === 'select' ? (
        <select value={value} onChange={e=>onChange(e.target.value)} className={selCls} required={req.is_required}>
          <option value="" className="bg-slate-900">— اختر —</option>
          {opts.map(o=>(
            <option key={o.value} value={o.value} className="bg-slate-900">{o.label_ar || o.label_en || o.value}</option>
          ))}
        </select>

      ) : req.field_type === 'date' ? (
        <input type="date" value={value} onChange={e=>onChange(e.target.value)} className={cls} required={req.is_required}/>

      ) : req.field_type === 'phone' ? (
        <input type="tel" value={value} onChange={e=>onChange(e.target.value)} placeholder={req.placeholder_ar||'05XXXXXXXX'} className={cls} dir="ltr" required={req.is_required}/>

      ) : req.field_type === 'textarea' ? (
        <textarea value={value} onChange={e=>onChange(e.target.value)} placeholder={req.placeholder_ar||''} className={cls + " resize-none"} rows={3} required={req.is_required}/>

      ) : req.field_type === 'url' ? (
        <input type="url" value={value} onChange={e=>onChange(e.target.value)} placeholder={req.placeholder_ar||'https://'} className={cls} dir="ltr" required={req.is_required}/>

      ) : req.field_type === 'file' ? (
        <div className="space-y-1.5">
          <label className={`flex items-center gap-3 px-4 py-3 rounded-xl border cursor-pointer transition-all ${uploading ? 'border-white/20 opacity-50' : value ? 'border-emerald-500/50 bg-emerald-500/10' : 'border-white/10 bg-white/5 hover:border-white/20'}`}>
            <input type="file" className="hidden" onChange={handleFileChange} disabled={uploading}
              accept={req.file_types || 'image/jpeg,image/png,image/webp,application/pdf'} />
            {uploading
              ? <><Spinner/><span className="text-white/50 text-sm">جارٍ الرفع...</span></>
              : value
              ? <><svg className="w-4 h-4 text-emerald-400 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7"/></svg><span className="text-emerald-300 text-sm truncate">{value.split('/').pop()}</span></>
              : <><svg className="w-4 h-4 text-white/40 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5m-13.5-9L12 3m0 0l4.5 4.5M12 3v13.5"/></svg><span className="text-white/40 text-sm">اضغط لاختيار ملف</span></>}
          </label>
          {uploadErr && <p className="text-red-400 text-xs">{uploadErr}</p>}
        </div>

      ) : (
        <input type="text" value={value} onChange={e=>onChange(e.target.value)} placeholder={req.placeholder_ar||''} className={cls} dir="ltr" required={req.is_required}/>
      )}
    </div>
  );
}

function NavBtns({ onPrev, onNext, color }) {
  return (
    <div className="flex gap-2 pt-1">
      {onPrev && <button type="button" onClick={onPrev} className="flex-1 py-3 rounded-2xl bg-white/10 text-white/70 text-sm font-semibold hover:bg-white/20 transition-colors">رجوع</button>}
      <button type="button" onClick={onNext} className={`flex-[2] py-3 rounded-2xl bg-gradient-to-r ${color} text-white font-bold text-sm hover:opacity-90 active:scale-[0.98] transition-all flex items-center justify-center gap-1`}>
        التالي
        <svg className="w-4 h-4 rotate-180" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7"/></svg>
      </button>
    </div>
  );
}

function ReviewCard({ title, rows }) {
  return (
    <div className="rounded-xl bg-white/5 border border-white/10 p-4">
      <p className="text-xs font-bold text-white/40 uppercase tracking-wider mb-3">{title}</p>
      {rows.map(([k,v]) => (
        <div key={k} className="flex justify-between items-center py-1.5 border-b border-white/5 last:border-0">
          <span className="text-white/50 text-sm">{k}</span>
          <span className="text-white text-sm font-semibold" dir="ltr">{v||'—'}</span>
        </div>
      ))}
    </div>
  );
}

function SubmitBtn({ loading, color, label }) {
  return (
    <button type="submit" disabled={loading}
      className={`w-full py-3.5 rounded-2xl font-bold text-white text-sm bg-gradient-to-r ${color} hover:opacity-90 active:scale-[0.98] transition-all shadow-lg disabled:opacity-50 flex items-center justify-center gap-2 mt-2`}>
      {loading ? <Spinner/> : label}
    </button>
  );
}

function Spinner() {
  return <span className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin inline-block"/>;
}
